export default __webpack_public_path__ + "static/zaru_collages_v6-17-51941c476cc6f84935676e9ca0286bda.png";